import styled, { css } from 'styled-components'
import { BaseColor, Typography, spacing, rem, themeColor, Breakpoint, breakpointEnding } from '~theme'
import { Button } from '~components/Button'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  user-select: none;
`

export const List = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  padding: 0 ${spacing(0.5)};
`

export const StyledButton = styled(Button).attrs({ size: 'small', color: 'base' })`
  margin-left: ${spacing(0.5)};
  margin-right: ${spacing(0.5)};

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }
`

interface PageButtonProps {
  isCurrent?: boolean
}

export const PageButton = styled(StyledButton).attrs<PageButtonProps>(({ isCurrent = false }) => ({
  color: isCurrent ? 'primary' : 'base',
  variant: 'outlined',
  shape: 'square',
}))<PageButtonProps>``

export const DotsButton = styled(StyledButton).attrs({
  shape: 'square',
})`
  pointer-events: none;
  touch-action: none;
  border: none;
`

interface DirectionButtonProps {
  isVisibleOnBreakpointSm?: boolean
}

export const DirectionButton = styled(StyledButton).attrs({ variant: 'outlined' })<DirectionButtonProps>`
  margin-left: ${spacing(0.75)};
  margin-right: ${spacing(0.75)};

  ${({ isVisibleOnBreakpointSm = true }) =>
    !isVisibleOnBreakpointSm &&
    css`
      @media (${breakpointEnding(Breakpoint.sm)}) {
        display: none;
      }
    `};
`

export const PageInfo = styled.div`
  flex-shrink: 0;
  min-width: ${rem(4)};
  color: ${themeColor(BaseColor.shade_60)};
  ${Typography.labelMedium};
  font-feature-settings: 'tnum';

  &:not(:empty) {
    margin-left: ${rem(22)};
    margin-right: ${rem(22)};
  }
`
